import { IColumnDefinition } from "../components/bidding/common/table/types/ColumnDefinition";
import { UserConfigColumn } from "../types/user-config/UserConfigColumn";
import { apiUtils } from "./api.utils";
import { ListBuilder } from "./ListBuilder";

class ColumnListBuilder<TEntity> extends ListBuilder<IColumnDefinition<TEntity>> {
    _config: UserConfigColumn[];
    _shouldUseColumnKey: boolean;
    constructor(config: UserConfigColumn[]) {
        super();
        this._config = config;
        this._shouldUseColumnKey = false;
    }

    useColumnKey(flag: boolean) {
        this._shouldUseColumnKey = flag;
        return this;
    }

    getKey(column: IColumnDefinition<TEntity>) {
        if(column.configKey) return column.configKey
        if(this._shouldUseColumnKey) return column.columnKey;

        return undefined;
    }

    add(...items: IColumnDefinition<TEntity>[]): ColumnListBuilder<TEntity> {
        const displayedItems = items.filter(i => {
            const key = this.getKey(i);
            return !key || this._config.some(c => c.displayed && key.localeCompare(c.name, undefined, { sensitivity: 'accent' }) === 0);
        });

        super.add(...displayedItems);
        return this;
    }

    result(): IColumnDefinition<TEntity>[] {
        const orderingMap = apiUtils.normalize(this._config, c => c.name.toLowerCase(), c => c.order);

        return [...this._result].sort((ac, bc) => {
            const aKey = this.getKey(ac)?.toLowerCase();
            const bKey = this.getKey(bc)?.toLowerCase();

            const a = aKey ? orderingMap[aKey] : 0;
            const b = bKey ? orderingMap[bKey] : 0;

            return a - b;
        });
    }
}

export const createColumnListBuilder = <TEntity>(config?: UserConfigColumn[], shouldUseColumnKey: boolean = false) => {
    return config
        ? new ColumnListBuilder<TEntity>(config).useColumnKey(shouldUseColumnKey)
        : new ListBuilder<IColumnDefinition<TEntity>>()
}
